import React from 'react';

import { DateRangePicker } from '@gogame/components';

import Filter from '../Filter';
import getTitle from '../getTitle';

const FilterDateRangePicker = ({
  title,
  name,
  withClear,
  withFavoriteActions,
  presets,
  minDate,
  maxDate,
  maxRange,
  placeholder,
  disabled,
  disableFuture,
  multiFields,
  actions,
  compareActions,
  required,
  ['data-cy']: dataCy,
}) => {
  return (
    <Filter
      title={title}
      required={required}
      name={name}
      withClear={withClear}
      withFavoriteActions={withFavoriteActions}
      multiFields={multiFields}
      actions={actions}
      compareActions={compareActions}
      renderComponent={({ label, value, onChange, actions }) => (
        <DateRangePicker
          data-cy={dataCy || name}
          label={label}
          value={value}
          onChange={onChange}
          actions={actions}
          presets={presets}
          minDate={minDate}
          maxDate={maxDate}
          maxRange={maxRange}
          placeholder={placeholder}
          disabled={disabled}
          disableFuture={disableFuture}
          checkPresetValue={true}
          padding={0}
        />
      )}
    />
  );
};

export default FilterDateRangePicker;
